<template>
    <div class="">
        <section class="d-flex flex-column h-full">
            <!-- <div class="fixed-header w-full"> -->
            <TopAppBar
            :leftBtnMode="leftBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
            ></TopAppBar>
         </section>
        <div id="tab1" class="t-color-content1 pdt-16 pdb-16 pdl-16 pdr-16 bg-white h-full-over">
            <div class="header-card mgb-16 bg-white  ">
                <div class="">
                <p class="font-b mgt-1 mgb-1 t-color-title t-center t-headline9 l-spacing66 pdl-16 pdr-16">{{badgeData?badgeData.name:'' | charLength }}</p>
                <!-- <p class="font-r mgt-8 mgb-1 t-color-content1 t-center t-body3 l-spacing42">{{$t(badgeData?badgeData.achievementTerms.text:'')}}</p> -->
                </div>
                <div class="rewardContent pdt-16 pdb-16 d-flex justify-content-center flex-column">
                <div class="crownWrapper position-relative d-flex align-items-center flex-column">
                    <img :src="badgeData?badgeData.on.resourceUri:''" alt="" class="crown160">
                    <img src="/images/reward/crown-shadow.png" alt="" class="shadow135">
                </div>
                <!-- <div class="t-color-content1 t-body1 mgt-22 mgb-0 t-center l-spacing48">온라인 강의 수료를 <span class="t-color-red1">{{badgeData?badgeData.number:''}}회</span> 달성했습니다.</div> -->
                <div class="t-color-content1 t-body1 mgt-22 mgb-0 t-center l-spacing48 preLine">{{badgeData?badgeData.description:''}}</div>
                <div class="t-color-content1 t-helper mgt-4 mgb-0 t-center mgb-40">{{$moment(badgeData?badgeData.achievedDate:'').format('YYYY. MM. DD')}}</div>
                </div>
                <!-- <div class="fixed-bottom pda-default">
                <a href="#" class="d-block t-center pdt-11 pdb-11 t-color-white btn-red b-radius4 mgt-40 b-shadow2 t-body2">{{$t('1716')}}</a>
                <a href="#" class="d-block bg-blue t-center pdt-11 pdb-11 t-color-red1 b-radius4 mgt-16 b-shadow2 t-body2">배지 공유하기</a>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import rewardApi from "@/api/rewardApi.js"
export default {
    name: 'BadgeDetail',
    data() {
        return {
            title:'',
            leftBtnMethod: () => { this.$router.go(-1)},
            badgeData:null,
            certificate:null
        }
    },
    filters:{
        charLength(value) {
            if(value.length>30){
                return value.substring(0,30)+".."
            } else {
                return value
            }

        },
    },
    components: {
        TopAppBar,
    },

    mixins: [topAppBarMixin],

    mounted() {
        let boxId = this.$router.currentRoute.params.boxid;
        let missionId = this.$router.currentRoute.params.missionid;
        this.setTopAppBarBackReward()
        this.fetchData(boxId,missionId)
    },
    methods:{
        
        fetchData(boxId,missionId){
            let parmas =  {boxId: boxId,missionId:missionId}
            rewardApi.badgeDetail(parmas).then((response) => {
                console.log('responseBadge',response)
                this.badgeData = response.data.data
            }).catch((err) => {})
        },
    }
}
</script>
<style scoped>
.h-full-over {
    height: 100vh;
}
.mdc-elevation--z3 {
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
    background-color: #ffffff;
  }

  .rewardTitle{
    font-size:16px;
  }
  .crown160{
    max-width: 160px;
  }
  .shadow135{
    max-width: 135px;
    height: 30px;
  }
  .preLine {
    white-space: pre-line;
  }
</style>